const XboxIcon = (props) => {
  return (
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 23 23"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_705_1741)">
        <path
          d="M3.40979 3.61303H3.39979C-0.57021 7.54303 -1.01021 13.813 2.36979 18.253C2.37979 18.273 2.40979 18.283 2.42979 18.273C2.44979 18.263 2.44979 18.233 2.43979 18.213C1.59979 15.593 5.91979 9.25303 8.14979 6.59303C8.14979 6.59303 8.15979 6.57303 8.16979 6.56303C8.16979 6.55303 8.16979 6.53303 8.14979 6.52303C4.38979 2.78303 3.38979 3.63303 3.39979 3.62303"
          fill="inherit"
        />
        <path
          d="M18.9898 3.61301H18.9998C22.9698 7.54301 23.4098 13.803 20.0298 18.243C20.0198 18.263 19.9898 18.273 19.9698 18.263C19.9498 18.253 19.9498 18.223 19.9598 18.203C20.8098 15.583 16.4798 9.23301 14.2498 6.58301C14.2498 6.58301 14.2398 6.56301 14.2298 6.55301C14.2298 6.54301 14.2298 6.52301 14.2498 6.51301C18.0098 2.77301 19.0098 3.63301 18.9898 3.62301"
          fill="inherit"
        />
        <path
          d="M11.2003 0.422974C13.2403 0.422974 15.2403 0.972974 16.9803 2.04297C17.0003 2.05297 17.0103 2.07297 17.0003 2.09297C16.9903 2.11297 16.9703 2.12297 16.9503 2.11297C14.8003 1.64297 11.5303 3.50297 11.2303 3.69297C11.2203 3.70297 11.2003 3.70297 11.1803 3.69297C10.3603 3.22297 7.34033 1.64297 5.44033 2.12297C5.42033 2.12297 5.39033 2.12297 5.38033 2.10297C5.37033 2.08297 5.38033 2.05297 5.40033 2.04297C7.14033 0.982974 9.15033 0.422974 11.2003 0.422974Z"
          fill="inherit"
        />
        <path
          d="M11.2004 9.323C11.2004 9.323 11.2304 9.323 11.2404 9.343C14.5604 11.873 20.2504 18.113 18.5104 19.883C14.3304 23.543 8.08036 23.543 3.89036 19.883C2.16036 18.113 7.84036 11.873 11.1604 9.343C11.1704 9.343 11.1804 9.323 11.2004 9.323Z"
          fill="inherit"
        />
      </g>
      <defs>
        <clipPath id="clip0_705_1741">
          <rect
            width="22.21"
            height="22.2"
            fill="inherit"
            transform="translate(0.0990601 0.422974)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default XboxIcon
